import { render, staticRenderFns } from "./SeletorAdministradoras.vue?vue&type=template&id=126f01c8&scoped=true"
import script from "./SeletorAdministradoras.vue?vue&type=script&lang=js"
export * from "./SeletorAdministradoras.vue?vue&type=script&lang=js"
import style0 from "./SeletorAdministradoras.vue?vue&type=style&index=0&id=126f01c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126f01c8",
  null
  
)

export default component.exports